import { ColorSegments, Segment } from '../leaflet-map.types';

export const calculateSegmentDashes = (
    segments: ColorSegments[],
    circumference: number
): Array<ColorSegments & Segment> => {
    let startPercentage = 0;

    return segments.map(segment => {
        const segmentLength = (segment.percentage / 100) * circumference;
        const dashArray = `${segmentLength} ${circumference - segmentLength}`;
        const dashOffset = circumference * (1 - startPercentage / 100);

        startPercentage += segment.percentage;

        return {
            ...segment,
            dashArray,
            dashOffset,
        };
    });
};
